(() => {
  const KEY = 'mewShip';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let last = null;
  try { last = JSON.parse(sessionStorage.getItem(KEY)); } catch (_) {}

  const truckLeft = p => `calc(${Math.min(p, 94)}% - 18px)`;

  function play(root) {
    const now = {
      state: root.dataset.state,
      progress: parseInt(root.dataset.progress, 10),
      current: parseInt(root.dataset.current, 10),
      msg: root.querySelector('#mewShipMsg').innerHTML,
    };
    const prev = last;

    if (prev && !reduced && (prev.current !== now.current || prev.state !== now.state)) {
      const fill  = root.querySelector('#mewBarFill');
      const truck = root.querySelector('#mewTruck');
      const bar   = root.querySelector('#mewBarOuter');
      const flash = root.querySelector('#mewFireFlash');
      const msg   = root.querySelector('#mewShipMsg');

      // Rewind to previous state, then let CSS transitions carry it to the new one.
      fill.style.transition = truck.style.transition = 'none';
      fill.style.width = prev.progress + '%';
      truck.style.left = truckLeft(prev.progress);
      void fill.offsetWidth;
      fill.style.transition = truck.style.transition = '';
      requestAnimationFrame(() => {
        fill.style.width = now.progress + '%';
        truck.style.left = truckLeft(now.progress);
      });

      // Message burn-out → settle-in.
      if (prev.msg && prev.msg !== now.msg) {
        msg.innerHTML = prev.msg;
        msg.classList.add('burn-out');
        setTimeout(() => {
          msg.innerHTML = now.msg;
          msg.classList.remove('burn-out');
          msg.classList.add('settle-in');
        }, 250);
      }

      if (now.state === 'done' && prev.state !== 'done') {
        flash.classList.add('bang');
        celebrate(root.dataset.celebrate, root.dataset.celebrateColors);
      } else if (now.state === 'almost' && prev.state !== 'almost') {
        bar.classList.add('shake');
      }
    }

    last = now;
    try { sessionStorage.setItem(KEY, JSON.stringify(now)); } catch (_) {}
  }

  function celebrate(kind, colorList) {
    if (!kind || kind === 'none' || reduced) return;
    const colors = (colorList || '').split(',').map(s => s.trim()).filter(Boolean);
    if (!colors.length) colors.push('#ffcc00', '#ff6b00', '#00c853');

    const c = document.createElement('canvas');
    Object.assign(c.style, { position: 'fixed', inset: '0', width: '100%', height: '100%', pointerEvents: 'none', zIndex: '2147483647' });
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const W = innerWidth, H = innerHeight;
    c.width = W * dpr; c.height = H * dpr;
    document.body.appendChild(c);
    const ctx = c.getContext('2d');
    ctx.scale(dpr, dpr);

    const P = [];
    const spawn = (x, y, n, speed, gravity) => {
      for (let i = 0; i < n; i++) {
        const a = Math.random() * Math.PI * 2, s = speed * (0.4 + Math.random());
        P.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 3, g: gravity, life: 1,
                 decay: 0.012 + Math.random() * 0.012, size: 3 + Math.random() * 4,
                 color: colors[i % colors.length], rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.3 });
      }
    };
    if (kind === 'confetti' || kind === 'both') spawn(W * 0.5, H * 0.35, 110, 9, 0.18);
    if (kind === 'fireworks' || kind === 'both') {
      let n = 0;
      const burst = () => {
        spawn(W * (0.25 + Math.random() * 0.5), H * (0.2 + Math.random() * 0.3), 50, 6, 0.06);
        if (++n < 3) setTimeout(burst, 320);
      };
      burst();
    }

    const t0 = performance.now();
    const tick = t => {
      ctx.clearRect(0, 0, W, H);
      let alive = 0;
      for (const p of P) {
        if (p.life <= 0) continue;
        alive++;
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.vx *= 0.985; p.rot += p.vr; p.life -= p.decay;
        ctx.save();
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      if (alive && t - t0 < 3200) requestAnimationFrame(tick); else c.remove();
    };
    requestAnimationFrame(tick);
  }

  function boot() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const scan = () => {
      const root = document.getElementById('mewShip');
      if (root) {
        if (!root.dataset.mewInit) { root.dataset.mewInit = '1'; play(root); }
      } else if (drawer.classList.contains('is-empty')) {
        last = { state: 'start', progress: 0, current: 0, msg: null };
        try { sessionStorage.setItem(KEY, JSON.stringify(last)); } catch (_) {}
      }
    };
    scan();
    new MutationObserver(scan).observe(drawer, { childList: true, subtree: true });
  }

  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', boot) : boot();
})();